import PersonasService from '../../services/PersonasService';

export const namespaced = true;

export const state = {
};

export const mutations = {
};

export const actions = {
  buscarPorNroIdentidad({}, {nroIdentidad, token}) {
    let request = null;
    token = token || {};
    token.cancel = () => {
      request.abort();
    };
    return PersonasService.getByNroDocumento(nroIdentidad, {
      before(req) {
        request = req;
      },
    }).then(r => r.json())
      .then(persons => persons[0] || null);
  },
};

export const getters = {};
